import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const TicketView = lazy(() => import("../components/Support/ParentTicketView.jsx"));
const TicketChatView = lazy(() => import("../components/Support/ParentTicketCreate.jsx"));
const HelpGuidesView = lazy(() => import("../components/Support/ParentHelpGuides.jsx"));
const SupportMetricsView = lazy(() => import("../components/Support/Admin/Metrics/SupportMetrics.jsx"));
const TaxonomyView = lazy(() => import("../components/Support/Admin/Settings/Taxonomy.jsx"));
const MacrosView = lazy(() => import("../components/Support/Admin/Settings/Macros.jsx"));
const TemplatesView = lazy(() => import("../components/Support/Admin/Settings/Templates.jsx"));
const SLARulesView = lazy(() => import("../components/Support/Admin/Settings/SLARules.jsx"));
const AlertsView = lazy(() => import("../components/Support/Admin/Settings/Alerts.jsx"));
const AgentsView = lazy(() => import("../components/Support/Admin/Settings/Agents.jsx"));
const IntegrationsView = lazy(() => import("../components/Support/Admin/Settings/Integrations.jsx"));
import SettingsLayout from "../components/Support/Admin/Settings/SettingsLayout.jsx";

export default [
  { path: ROUTES.SUPPORT.TICKET, element: <LazyRoute><TicketView /></LazyRoute> },
  { path: ROUTES.SUPPORT.CHAT, element: <LazyRoute><TicketChatView /></LazyRoute> },
  { path: ROUTES.SUPPORT.HELP_GUIDES, element: <LazyRoute><HelpGuidesView /></LazyRoute> },
  { path: ROUTES.SUPPORT.METRICS, element: <LazyRoute><SupportMetricsView /></LazyRoute> },
  {
    element: <SettingsLayout />,
    children: [
      { path: ROUTES.SUPPORT.TAXONOMY, element: <LazyRoute><TaxonomyView /></LazyRoute> },
      { path: ROUTES.SUPPORT.MACROS, element: <LazyRoute><MacrosView /></LazyRoute> },
      { path: ROUTES.SUPPORT.TEMPLATES, element: <LazyRoute><TemplatesView /></LazyRoute> },
      { path: ROUTES.SUPPORT.SLA, element: <LazyRoute><SLARulesView /></LazyRoute> },
      { path: ROUTES.SUPPORT.ALERTS, element: <LazyRoute><AlertsView /></LazyRoute> },
      { path: ROUTES.SUPPORT.AGENTS, element: <LazyRoute><AgentsView /></LazyRoute> },
      { path: ROUTES.SUPPORT.INTEGRATIONS, element: <LazyRoute><IntegrationsView /></LazyRoute> },
    ]
  }
];
